'use client'

import { cn } from '@/lib/utils'
import { Home, LayoutGrid, User, Users } from 'lucide-react'
import { Button } from '@/registry/default/ui/button'
import { usePathname, useRouter } from 'next/navigation'

const navigation = [
  { name: '首页', href: '/', icon: Home, dot: true },
  { name: '合作', href: '/market-overview', icon: Users },
  { name: '广场', href: '/plaza', icon: LayoutGrid },
  { name: '我的', href: '/profile', icon: User },
]

export function Navigation({ className }: { className?: string }) {
  const router = useRouter()
  const pathName = usePathname();
  return (
    <nav className={cn('fixed w-full md:max-w-xl md:border-x justify-self-center bottom-0 py-2 left-0 right-0 border-t bg-card ', className)}>
      <div className="md:container w-full h-full flex justify-between ">
        {navigation.map((item) => (
          <Button
            key={item.name}
            onClick={()=>{
              router.push(item.href)
            }}
            variant={'ghost'}
            className="flex flex-col hover:bg-transparent p-2 rounded-none items-center min-w-[80px]"
          >
            <div className={cn("relative h-full",pathName == item.href ? "text-primary" :"text-muted-foreground")}>
              <item.icon className="h-5 w-5" />
              {item.dot && (
                <span className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-red-500" />
              )}
            </div>
            <span className={cn("mt-1 font-medium text-xs",pathName == item.href ? "text-primary" :"text-muted-foreground")}>{item.name}</span>
          </Button>
        ))}
      </div>
    </nav>
  )
}

